import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import homeImage from '../assets/home_1.jpg'
import ReactGA from 'react-ga'




const homeStyles = {
    width: "90%",
    maxWidth: "50em",
    margin: "20px auto",
    border: "1px solid #ddd",
    borderRadius: "5px",
    padding: "10px",
    clear:'both'
  };
  const imageStyle= {
    float: "left",
    margin:"0px 5px 0px 5px",
    height: "300px"
}


class Home extends Component {

    componentDidMount() {
        ReactGA.pageview(window.location.pathname + window.location.search);
    }
    render(
    ) {
        return (
            <div>
                <h2>Software Developer by day, software developer by night...</h2>
                <hr/>

                <img  style={imageStyle} src={homeImage}></img>
                <h5>
               Welcome to my new site!
               </h5>
               <p>
                   Check out the new site, new features will be added regularly and be sure to register to get all the latest updates
                   and blog posts from forrestsmietanski.com! 
                   </p>


               <div style={{clear:'both'}}/>

              
            </div>
        );
    }
}

export default Home;





// WEBPACK FOOTER //
// ./src/components/Home.jsx